import { FC, memo, ReactNode } from 'react';
import './style.scss';
import moment from 'moment';
import { IWHLog } from '../../store/WorkingHoursLogStore';
import { WH_LOG_COLUMN } from '../../constants/WHLogRow';
import { localeStore } from '~/mobx/localesStore';
import { modalStore } from '~/mobx/modalStore';

const getBusinessDateFormat = (date: string | null) => {
  if (date === null) {
    return '-';
  }

  return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY, h:mm:ss A');
};

const getCellText = (txt: any) => {
  if (!txt) {
    return '-';
  }

  return txt;
};

const showModal = (whLog: IWHLog): void => {
  modalStore.openWorkingHoursLogModal(whLog);
};

interface IProps {
  whLog?: IWHLog;
}

export const WHLogRowCell: FC<{ children: ReactNode; cellName: WH_LOG_COLUMN; onClick?: () => void }> = ({
  children,
  cellName,
  onClick,
}): JSX.Element => {
  return (
    <div className={`cell cell-${cellName} ${onClick ? 'cursor-pointer' : ''}`} onClick={onClick}>
      {children}
    </div>
  );
};

const WHLogListRow: FC<IProps> = ({ whLog }: IProps): JSX.Element | null => {
  if (!whLog) {
    return null;
  }

  const defaultClasses = 'family-medium text-size-16 text-elipsis';

  const profile = getCellText(whLog.profile);
  const date = getBusinessDateFormat(whLog.date);
  const action = getCellText(whLog.action);
  const author = getCellText(whLog.author);
  const details = localeStore.t('wh_log_details_btn');

  return (
    <div className="branch-log-list">
      <WHLogRowCell cellName={WH_LOG_COLUMN.PROFILE}>
        <p className={defaultClasses}>{profile}</p>
      </WHLogRowCell>

      <WHLogRowCell cellName={WH_LOG_COLUMN.DATE}>
        <p className={defaultClasses}>{date}</p>
      </WHLogRowCell>

      <WHLogRowCell cellName={WH_LOG_COLUMN.ACTION}>
        <p className={defaultClasses}>{action}</p>
      </WHLogRowCell>

      <WHLogRowCell cellName={WH_LOG_COLUMN.AUTHOR}>
        <p className={defaultClasses}>{author}</p>
      </WHLogRowCell>

      <WHLogRowCell cellName={WH_LOG_COLUMN.DETAILS}>
        <p className={defaultClasses + ' text-blue'} onClick={() => showModal(whLog)}>
          {details}
        </p>
      </WHLogRowCell>
    </div>
  );
};

export default memo(WHLogListRow);
